module.exports = __webpack_public_path__ + "static/media/band-photo.6cc6fbb0.jpeg";